var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/close"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2.8L25.2 0L14 11.2L2.8 0L0 2.8L11.2 14L0 25.2L2.8 28L14 16.8L25.2 28L28 25.2L16.8 14L28 2.8Z",
    fill: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_539_22579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2.8L25.2 0L14 11.2L2.8 0L0 2.8L11.2 14L0 25.2L2.8 28L14 16.8L25.2 28L28 25.2L16.8 14L28 2.8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_539_22579)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ce65d15881289a539ce492cc717e8465.svg";
export { ForwardRef as ReactComponent };